// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__263qY","productName":"Table_productName__3wQUU"};